import { gql } from "@apollo/client";
import {
    organizationDetailsFragment,
    organizationPermissionsFragment,
    organizationAuthorizedOperationsFragment,
} from "../fragments";

export const getOrganizations = gql`
    query GetCameraKitOrganizations($includeAllOrgs: Boolean = false) {
        getOrganizations: getCameraKitOrganizations(input: { includeUnenabledOrgs: $includeAllOrgs }) {
            organizations {
                ...OrganizationDetails
                ...OrganizationPermissions @skip(if: $includeAllOrgs)
                ...OrganizationAuthorizedOperations @skip(if: $includeAllOrgs)
                appsManagementEnabled @skip(if: $includeAllOrgs)
                accountIds
            }
        }
    }
    ${organizationDetailsFragment}
    ${organizationPermissionsFragment}
    ${organizationAuthorizedOperationsFragment}
`;
